import React from "react"
import PropTypes from "prop-types"
import Modal from "react-bootstrap/Modal"

const PortfolioModal = ({ show, onHide, children }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton closeLabel="Close"></Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  )
}

PortfolioModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
}

export default PortfolioModal
